module.exports = __webpack_public_path__ + "static/media/personal_data_we_hold.065fe752.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tab-images/personal_data_we_hold.jpg
// module id = 219
// module chunks = 0